import(/* webpackMode: "eager" */ "D:\\FekerTech\\Shahen Website New\\src\\app\\terms-and-conditions\\page.jsx");
